export const graphWidth = 1120;
export const graphSidePadding = 50;

export const noDataMessage =
  'There is no data for your selected date range or filters. Please try again.';

export const badDateRangeMessage =
  'Select more than a single day in the date range to view performance data';
